import { AbstractStatefulLoadable } from '../../types/lux/stateful'

export default AbstractStatefulLoadable

/** @constructor @extends {AbstractStatefulLoadable} @suppress {checkTypes} */ function _AbstractStatefulLoadable() {}
AbstractStatefulLoadable.__implement(
  _AbstractStatefulLoadable.prototype = /** @type {!AbstractStatefulLoadable} */ ({
    resetLoadingState() {
      const { asIStateful: { setState } } = this
      setState({
        loading: false,
        error: null,
        errorText: '',
      })
    },
    async wrapLoader(fn,throwErrors) {
      const{asIStatefulLoadable:{resetLoadingState,
        asIStateful:{setState}}}=this
      try {
        resetLoadingState()
        setState({loading:true})
        return await fn()
      } catch (error) {
        setState({error,errorText:error.message})
        if (throwErrors) {
          throw error
        }
      } finally {
        setState({loading:false})
      }
    },
  }),
)